module.exports = __webpack_public_path__ + "static/media/userImage.cac3463f.svg";